module.exports = __webpack_public_path__ + "img/Pain_Single_Frame_0001.05d54af1.jpg";